import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router';
import { useShell } from '@/context/shell-context';
import { usePwlJugSelf } from '@hooks/register/use-pwl-jug-self';
import { useSession } from '@hooks/security/use-session';
import { useLocalize } from '@hooks/use-localize';

const PwlJugSelf = () => {
    const { registrationId, editKey } = useSession();
    const { confirm, error } = usePwlJugSelf(registrationId, editKey);
    const t = useLocalize(useShell().languageData);

    const hasConfirmed = useRef(false);
    const [isConfirmed, setIsConfirmed] = useState(false);

    useEffect(() => {
        if (hasConfirmed.current) return;

        hasConfirmed.current = true;

        confirm().then((result) => setIsConfirmed(result.ok));
    }, [confirm]);

    if (error) {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xs-12">
                        <div className="alert alert-danger">{error}</div>
                    </div>
                </div>
            </div>
        );
    }

    // BusyOverlay covers the wait.
    if (!isConfirmed) return null;

    return (
        <div className="container-fluid">
            <div className="row row-margined">
                <div className="col-xs-12 col-sm-7 col-sm-offset-0">
                    <div className="row row-margined">
                        <div className="col-xs-12">
                            <h1>{t('DashLabel_ThankYou', 'Thank You')}</h1>
                            <p>
                                {t(
                                    'DashLabel_ThankYouWeWillCheckBackWithYouInAboutAWeekToSeeIfYouVeAcquired',
                                    "Thank you, we will check back with you in about a week to see if you've acquired a 24-hour urine collection jug",
                                )}
                                .
                            </p>
                        </div>
                    </div>

                    <div className="row row-margined">
                        <div className="col-xs-12">
                            <Link className="btn btn-primary" to="/register/donate">
                                {t('DashLabel_BackToDashboard', 'Back to Dashboard')}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PwlJugSelf;
